import axios from 'axios';
import {HOST} from '../constants';
import {ContentType, FormMethod, IElementForm} from '../incase-domain/elements/form';

export function saveFormElement(
    formElementId: string,
    formData: FormData,
    runFileId: string | undefined,
    presentationId: string | undefined
): Promise<IElementForm & {failed?: boolean}> {
    return axios
        .post(`${HOST}/player/formElement/save/${formElementId}`, {
            formData: Object.fromEntries(formData),
            runFileId,
            presentationId,
        })
        .then((response) => response.data)
        .catch(() => ({failed: true}));
}

export function sendFormToExternalService(
    url: string,
    method: FormMethod,
    contentType: ContentType,
    formData: FormData
): Promise<unknown & {failed?: boolean}> {
    let options;
    switch (contentType) {
        case ContentType.JSON:
            options = {
                method,
                data: Object.fromEntries(formData),
                headers: {'Content-Type': contentType},
                url,
            };
            break;
        case ContentType.URLENCODED:
            // eslint-disable-next-line no-case-declarations
            const queryParams = Object.entries(Object.fromEntries(formData))
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
            options = {
                method,
                headers: {'Content-Type': contentType},
                url: `${url}?${queryParams}`,
            };
            break;
        case ContentType.FORMDATA:
            options = {
                method,
                data: Object.fromEntries(formData),
                headers: {'Content-Type': contentType},
                url,
            };
            break;
        default:
            options = {
                method,
                data: Object.fromEntries(formData),
                headers: {'Content-Type': contentType},
                url,
            };
    }

    return axios(options)
        .then((response) => response.data)
        .catch(() => ({failed: true}));
}
